import React from 'react';

import './ResumeFooter.scss';

import { renderFooterContent } from './renderers';
import { FooterContentProps } from './types';
import { useFooterContext } from './hooks/useFooterContext';

export interface ResumeFooterProps {
  isHidden?: boolean;
  isBrokerMode?: boolean;
  [key: string]: any;
}

export const ResumeFooter = (props: ResumeFooterProps) => {
  const { isHidden, isBrokerMode } = props;
  const className = isHidden ? 'resume-footer hidden' : 'resume-footer';

  return (
    <div className={className}>
      <p>Update your loan</p>
      <FooterContent oneLine hideLastStep firstPerson isBrokerMode={isBrokerMode} dropdownCustomWidths={{ 0: '300px', 4: '250px', 5: '200px'}} {...props} />
    </div>
  );
};

export const FooterContent = (props: FooterContentProps) => {
  const context = useFooterContext(props);

  if (!context) {
    return null;
  }

  return renderFooterContent(context);
};

export { getText } from './utils/getText';

